import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  BooleanCons,
  EstatusTypeCard,
  LineProductCons,
  MessageType, StringConst
} from 'src/app/constants/const';
import { Messages } from 'src/app/constants/messages';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { GeneralMessage, TypeIcon } from 'src/app/model/device/message.model';
import {
  ProductAttributes, TypeShoppingCar
} from 'src/app/model/http/myActivity.model';
import {
  IMoreProducts, SendTypeCart
} from 'src/app/model/http/shoppingList';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/services/dialog.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { v4 as uuidv4 } from 'uuid';
import { ReloadShoppingCar } from 'src/app/model/local/shopping-cart';
@Component({
  selector: 'app-save-shopping-cart-button',
  templateUrl: './save-shopping-cart-button.component.html',
  styleUrls: ['./save-shopping-cart-button.component.scss'],
})
export class SaveShoppingCartButtonComponent implements OnInit, OnDestroy {
  @Input() itemCode = StringConst.empty;
  @Input() isLine = StringConst.empty;
  @Input() typeCart = EstatusTypeCard.withoutTypeCard;
  @Input() productAtributtes: ProductAttributes[] = [];
  @Input() cartOrigin = EstatusTypeCard.withoutTypeCard;
  @Input() cartDestination = EstatusTypeCard.withoutTypeCard;
  @Input() imageRoute = StringConst.empty;
  @Input() buttonText = StringConst.empty;
  componentId = uuidv4();
  subscriptions = new Subscription();

  constructor(
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private observableService: ObservableService,
    private dialogService: DialogService,
    private shoppingCartService: ShoppingCartService
  ) { }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.observableService.getResultGeneralNotification().subscribe((res) => {
        this.addToShoppingCart(res);
      })
    );
  }

  saveToLater(): void {
    if (this.isLine === LineProductCons.yes) {
      this.sendToShoppinCart();
      return;
    }
    this.validateProduct();
  }

  validateProduct(): void {
    const queryParams = this.getQueryParams();
    this.shoppingCartService.checkMoreProducts(queryParams).subscribe((res) => {
      this.validateExist(res.response ?? []);
    });
  }

  getQueryParams(): string {
    return `?cardCode=${this.localStorageService.getCardCodeGeneral()}&itemcode=${this.itemCode
      }&typecart=${this.cartDestination}`;
  }

  validateExist(list: IMoreProducts[]): void {
    let showMessage = BooleanCons.false;
    this.productAtributtes.forEach((product) => {
      const filterList =
        list[0]?.itemAttributes.filter(
          (atributte) =>
            atributte.container === product.container &&
            atributte.label !== product.label
        ) ?? [];
      showMessage = this.commonService.calculateTernary(
        filterList.length > 0,
        BooleanCons.true,
        showMessage
      );
    });
    if (showMessage) {
      this.showMessage();
    } else {
      this.sendToShoppinCart();
    }
  }

  showMessage(): void {
    const message = this.commonService.calculateTernary(
      this.cartDestination === EstatusTypeCard.savedCart,
      Messages.addNewProductToSavedCart,
      Messages.addNewProduct);
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      isButtonCancel: true,
      textToShow: message,
      typeIcon: TypeIcon.question,
      typeMessage: MessageType.sendToShoppingCart,
      itemCode: this.itemCode,
      componentId: this.componentId,
    });
  }

  addToShoppingCart(res: GeneralMessage): void {
    if (
      this.commonService.validateAndValue([
        res.componentId === this.componentId,
        res.wasOk === true,
      ])
    ) {
      this.sendToShoppinCart();
    }
  }

  sendToShoppinCart(): void {
    const body: SendTypeCart = {
      cardCode: this.localStorageService.getCardCode(),
      cartTypeDestination: this.cartDestination,
      cartTypeSender: this.cartOrigin,
      products: [
        {
          itemCode: this.itemCode,
        },
      ],
    };
    this.shoppingCartService.saveOneProductInSavedCart(body).subscribe(() => {
      const messageDict: { [key: number]: string } = {
        1: `Producto ${this.itemCode} ${Messages.oneProductSavedInSavedCart}`,
        5: `Producto ${this.itemCode} ${Messages.oneProductSavedICart}`,
      };
      const data = this.commonService.getTypeReloadShoppingCar(0, this.typeCart);
      this.observableService.setReloadShoppingCar(data);
      this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
        typeIcon: TypeIcon.success,
        textToShow: messageDict[this.typeCart],
        isButtonCancel: false,
        typeMessage: MessageType.none,
      });
    });
  }
}
